import styled from 'styled-components';
import SportsbookListItemLink from '../../../components/sportsbook-list-item-link';
import { Caption } from '@comeon/ui';

const MenuWrapper = styled.div`
	padding: 12px;
	border-radius: var(--base-radius-large);
	background-color: var(--main-surface-1);
	border: 1px solid var(--generic-stroke-10-percent);
`;

const MenuList = styled.ul`
	display: flex;
	flex-direction: column;
`;

const MenuListItem = styled(SportsbookListItemLink)`
	background-color: unset;

	a {
		padding: 12px;

		div:first-of-type {
			margin-right: 8px;
		}
	}

	p {
		font: var(--label-bold);
	}

	svg {
		height: 24px;
		width: 24px;
	}

	@media (hover: hover) and (pointer: fine) {
		&:hover {
			p,
			svg {
				color: var(--main-text-primary);
				fill: var(--main-text-primary);
			}
		}
	}
`;

const MenuHeader = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 6px 0;
`;

const MenuHeaderLabel = styled(Caption)``;

export { MenuWrapper, MenuList, MenuListItem, MenuHeader, MenuHeaderLabel };
